import { DeploymentType, WorkspaceConfiguration } from '@citrite/workspace-ui-platform';
import {
	AppProtectionConfigAccessor,
	AuthConfigAccessor,
	DetailedDesktopAccessor,
	FeatureCanaryConfigAccessor,
	LaunchConfigAccessor,
} from 'Configuration/accessors';
import { HTML5ConfigAccessor } from 'Configuration/accessors/HTML5ConfigAccessor';

export class ConfigurationService {
	private workspaceConfiguration: WorkspaceConfiguration;
	public appProtectionConfiguration: AppProtectionConfigAccessor;
	public featureCanaryConfiguration: FeatureCanaryConfigAccessor;
	public authConfiguration: AuthConfigAccessor;
	public launchConfiguration: LaunchConfigAccessor;
	public html5Configuration: HTML5ConfigAccessor;
	public detailedDesktopConfiguration: DetailedDesktopAccessor;

	public constructor(workspaceConfiguration: WorkspaceConfiguration) {
		this.workspaceConfiguration = workspaceConfiguration;
		this.featureCanaryConfiguration = new FeatureCanaryConfigAccessor(
			workspaceConfiguration
		);
		this.authConfiguration = new AuthConfigAccessor(workspaceConfiguration, this);
		this.appProtectionConfiguration = new AppProtectionConfigAccessor(
			workspaceConfiguration
		);
		this.launchConfiguration = new LaunchConfigAccessor(workspaceConfiguration, this);
		this.html5Configuration = new HTML5ConfigAccessor(workspaceConfiguration, this);
		this.detailedDesktopConfiguration = new DetailedDesktopAccessor(
			workspaceConfiguration,
			this
		);
	}

	public isCloudDeployment(): boolean {
		return this.workspaceConfiguration.deploymentType === DeploymentType.Cloud;
	}

	public isOnPremDeployment(): boolean {
		return this.workspaceConfiguration.deploymentType === DeploymentType.OnPrem;
	}
}
